export const BUSINESS = {
  name: "UNDERCLEAN",
  owner: "Oussama JADID",
  email: "UNDERCLEAN@OUTLOOK.FR",
  phone: "(+33) 07-57-83-40-87",
  address: "2 Place Jean V, 44000 Nantes",
  siret: "131 387 250 00015",
};

export const NAV = [
  { id: "services", label: "Prestations" },
  { id: "engagements", label: "Engagements" },
  { id: "societe", label: "La société" },
  { id: "devis", label: "Devis" },
];

export const SERVICES = [
  {
    key: "bureaux",
    title: "Bureaux & tertiaire",
    text: "Entretien régulier de vos espaces de travail : postes, sols, sanitaires, salles de réunion et espaces communs.",
    img: "/assets/bureaux.jpg",
    span: "md:col-span-2 md:row-span-2",
  },
  {
    key: "vitrerie",
    title: "Vitrerie",
    text: "Vitres, baies, vitrines et façades vitrées : une transparence nette, sans traces.",
    img: "/assets/tower.jpg",
    span: "md:row-span-2",
  },
  {
    key: "remise",
    title: "Remise en état",
    text: "Après travaux, déménagement ou fin de bail : on vous rend des lieux prêts à vivre.",
    img: "/assets/renov.jpg",
    span: "",
  },
  {
    key: "batiments",
    title: "Bâtiments",
    text: "Halls, cages d'escalier, parties communes et abords d'immeubles.",
    img: "/assets/facade.jpg",
    span: "",
  },
  {
    key: "locaux",
    title: "Locaux professionnels",
    text: "Commerces, cabinets, ateliers, showrooms : un lieu propre qui inspire confiance à vos clients.",
    img: "/assets/locaux.jpg",
    span: "md:col-span-2",
  },
  {
    key: "associes",
    title: "Services associés",
    text: "Désinfection des points de contact, sanitaires, interventions ponctuelles et prestations sur mesure.",
    img: "/assets/gloves.jpg",
    span: "md:col-span-2",
  },
];

export const ENGAGEMENTS = [
  {
    title: "Rigueur",
    text: "Chaque intervention suit un protocole clair, pièce par pièce, pour un résultat constant et contrôlé.",
  },
  {
    title: "Transparence",
    text: "Un devis gratuit, détaillé et sans surprise. Vous savez exactement ce qui est fait, et quand.",
  },
  {
    title: "Réactivité",
    text: "Une réponse rapide à chaque demande et un interlocuteur unique, joignable directement.",
  },
  {
    title: "Sur-mesure",
    text: "Horaires, fréquence, périmètre : la prestation s'adapte à votre activité, pas l'inverse.",
  },
];

export const QUOTE_SERVICES = ["Bureaux", "Vitres", "Remise en état", "Locaux professionnels", "Bâtiments", "Désinfection", "Autre"];
export const SURFACES = ["10–50 m²", "50–100 m²", "100–300 m²", "300–500 m²", "500–1000 m²", "+1000 m²"];
export const FREQUENCIES = ["Ponctuelle", "Quotidienne", "Hebdomadaire", "Mensuelle", "À définir"];

export const MARQUEE = [
  "Nettoyage de bureaux",
  "Vitrerie",
  "Remise en état",
  "Locaux professionnels",
  "Bâtiments",
  "Propreté et services",
];
